/* tslint:disable */
/* eslint-disable */
/* @relayHash 3115eaf98a1e0496f520ab5371809e5d */

import { ConcreteRequest } from "relay-runtime";
export type ImagePreviewSearchQueryVariables = {
    query: string;
};
export type ImagePreviewSearchQueryResponse = {
    readonly imageSearch: {
        readonly images: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly url: string;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type ImagePreviewSearchQuery = {
    readonly response: ImagePreviewSearchQueryResponse;
    readonly variables: ImagePreviewSearchQueryVariables;
};



/*
query ImagePreviewSearchQuery(
  $query: String!
) {
  imageSearch(query: $query) {
    images(first: 1) {
      edges {
        node {
          id
          url(size: LARGE_SQUARE)
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "imageSearch",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "ImageSearch",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": "images(first:1)",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "ImageConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Image",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "size",
                        "value": "LARGE_SQUARE"
                      }
                    ],
                    "storageKey": "url(size:\"LARGE_SQUARE\")"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ImagePreviewSearchQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ImagePreviewSearchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ImagePreviewSearchQuery",
    "id": null,
    "text": "query ImagePreviewSearchQuery(\n  $query: String!\n) {\n  imageSearch(query: $query) {\n    images(first: 1) {\n      edges {\n        node {\n          id\n          url(size: LARGE_SQUARE)\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '1946167cffa31175915f243fb326b08a';
export default node;
